module.exports = __webpack_public_path__ + "static/a-xx-010-art-aedee539f670204f690f06a427ba8b4f.jpg";